/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type {
  AuthLoginVerifyCodeOptions,
  AuthLoginVerifyCodeResponses,
} from '../models/AuthLoginVerifyCode'
import {
  authLoginVerifyCodeResponseSchema,
  authLoginVerifyCodeErrorSchema,
  authLoginVerifyCodeBodySchema,
} from '../schemas/authLoginVerifyCodeSchema'

/**
 * @summary Second login step: the emailed code for the pending token from `auth/login` → the same response as a
 * completed login (token pair + user). With `rememberDevice` this browser skips the code for 60 days.
 * Every failure (unknown/expired challenge, wrong code, 5th wrong code, disabled or locked account) returns the
 * same error; after the 5th wrong code the user must log in again.
 * {@link /api/v4/auth/login/verifyCode}
 */
export function authLoginVerifyCode<ThrowOnError extends boolean = true>(
  options: Options<AuthLoginVerifyCodeOptions, ThrowOnError>
): Unwrappable<RequestResult<AuthLoginVerifyCodeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/login/verifyCode',
      validator: {
        request: authLoginVerifyCodeBodySchema,
        response: authLoginVerifyCodeResponseSchema,
        error: authLoginVerifyCodeErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<AuthLoginVerifyCodeResponses, ThrowOnError>>
  )
}
